import React, { type PropsWithChildren } from 'react';
import cx from 'classnames';
import {
  TriangleExclamationFill,
  CircleInfoFill,
  CircleClockFill,
  CircleExclamationFill,
  CircleCheckFill,
} from '@design-systems/icons';
import stylesheet from './IconBadge.css';

type FeedbackIconProps = {
  variant?: string;
  size?: 'small' | 'medium' | 'large';
};

const FeedbackIcon = ({ variant, size }: FeedbackIconProps) => {
  const icon =
    variant === 'success' ? (
      <CircleCheckFill size={size} color="var(--color-ui-positive)" />
    ) : variant === 'warning' ? (
      <CircleExclamationFill size={size} color="var(--color-ui-attention)" />
    ) : variant === 'error' ? (
      <TriangleExclamationFill size={size} color="var(--color-ui-negative)" />
    ) : variant === 'info' ? (
      <CircleInfoFill size={size} color="var(--color-ui-info)" />
    ) : (
      <CircleClockFill size={size} color="var(--color-ui-neutral)" />
    );
  return icon;
};

export type IconBadgeProps = PropsWithChildren<{
  type?: 'default' | 'success' | 'warning' | 'error' | 'info';
  hideLabel?: boolean;
}>;

const IconBadge = React.forwardRef<HTMLSpanElement, IconBadgeProps>(
  function IconBadge({ children, type = 'default', hideLabel }, ref) {
    return (
      <span className={cx(stylesheet.root, stylesheet[type])} ref={ref}>
        <span className={stylesheet.icon}>
          <FeedbackIcon variant={type} size="small" />
        </span>
        <span
          className={cx(stylesheet.label, {
            'wink-visually-hidden': hideLabel,
          })}
        >
          {children}
        </span>
      </span>
    );
  },
);

export default IconBadge;
